import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AxiosError } from 'axios';

function getTimezoneInfo() {
  const localDate = new Date();
  const offsetFromUtc = Math.abs(localDate.getTimezoneOffset() / 60) * -1;
  const dateInfo = localDate
    .toLocaleString('en-us', { timeZoneName: 'short' })
    .split(' ');
  return {
    offsetFromUtc,
    timezoneAbbreviation: dateInfo[dateInfo.length - 1],
  };
}

export const createClassSession = createAsyncThunk(
  'classSession/createClass',
  async (
    params: {
      Name: string;
      UtcStartTime: string;
      UtcEndTime: string;
      UserID: string;
      AccountID: string;
      ShouldAutoAnswer: boolean;
      Participants: object;
    },
    { rejectWithValue }
  ) => {
    console.log('createClass params', params);
    const { offsetFromUtc, timezoneAbbreviation } = getTimezoneInfo();
    try {
      const response = await api.post(
        '/class_session',
        {
          ...params,
          GMTOffset: offsetFromUtc,
          TimezoneAbbreviation: timezoneAbbreviation,
        },
        {
          timeout: 30000,
        }
      );
      console.log('createClass response', response);
      return response.data;
    } catch (err) {
      const error = err as AxiosError;
      console.log('createClass error', error);
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateClassSession = createAsyncThunk(
  'classSession/updateClass',
  async (params: any, { rejectWithValue }) => {
    console.log('updateClass params', params);
    let dataParams = Object.assign({}, params);
    delete dataParams.ID;
    console.log('>>>>>>', dataParams);
    const { offsetFromUtc, timezoneAbbreviation } = getTimezoneInfo();
    try {
      const response = await api.put(
        `/class_session/${params.ID}`,
        {
          ...dataParams,
          GMTOffset: offsetFromUtc,
          TimezoneAbbreviation: timezoneAbbreviation,
        },
        {
          timeout: 30000,
        }
      );
      console.log('updateClass response', response.data);
      return response.data;
    } catch (err) {
      const error = err as AxiosError;
      console.log('createClass error', error);
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const cancelClassSession = createAsyncThunk(
  'classSession/cancelClass',
  async (
    params: any
    //   ID: string;
    //   Name: string;
    //   UtcStartTime: string;
    //   UtcEndTime: string;
    //   UserID: string;
    //   AccountID: string;
    //   ShouldAutoAnswer: boolean;
    //   Participants : object;
  ) => {
    console.log('cancelClass params', params);
    let dataParams = Object.assign({}, params);
    delete dataParams.ID;
    console.log('>>>>>>', dataParams);
    const response = await api.put(
      `/class_session/${params.ID}/cancel`,
      dataParams,
      {
        timeout: 30000,
      }
    );
    console.log('cancelClass response', response.data);
    return response.data;
  }
);

export const startClassSession = createAsyncThunk(
  'classSession/startClass',
  async (
    params: any
    //   ID: string;
    //   Name: string;
    //   UtcStartTime: string;
    //   UtcEndTime: string;
    //   UserID: string;
    //   AccountID: string;
    //   ShouldAutoAnswer: boolean;
    //   Participants : object;
  ) => {
    console.log('startClass params', params);
    let dataParams = Object.assign({}, params);
    delete dataParams.ID;
    console.log('>>>>>>', dataParams);
    const response = await api.put(`/class_session/${params.ID}`, dataParams, {
      timeout: 30000,
    });
    console.log('startClass response', response.data);
    return response.data;
  }
);

export const getClassSessions = createAsyncThunk(
  'classSession/getClassSessions',
  async (params: { startDate: string; endDate: string; accountId: string }) => {
    console.log('getClassSessions params', params);
    const response = await api.get(
      `class_session?startDate=${params.startDate}&endDate=${params.endDate}&accountId=${params.accountId}`,
      {
        timeout: 30000,
      }
    );
    console.log('getClassSessions response', response.data);
    return response.data;
  }
);

const initialState: {
  status: string;
  error: string;
  session: any;
  sessions: any;
  cancelSession: any;
  startSession: any;
} = {
  status: '',
  error: '',
  session: {},
  sessions: {},
  cancelSession: {},
  startSession: {},
};

const classSessionSlice = createSlice({
  name: 'classSession',
  initialState: initialState,
  reducers: {
    sessionSliceClean(state, action) {
      console.log('sessionSliceClean', action);
      state.session.saving = false;
      state.session.saved = false;
      state.session.error = '';

      state.sessions.pending = false;
      state.sessions.complete = false;
      state.sessions.error = '';

      state.startSession.saving = false;
      state.startSession.saved = false;
      state.startSession.error = '';

      state.cancelSession.saving = false;
      state.cancelSession.saved = false;
      state.cancelSession.error = '';
    },
  },
  extraReducers: (builder) => {
    //getClass
    builder.addCase(getClassSessions.pending, (state) => {
      state.sessions.pending = true;
      state.sessions.complete = false;
      state.sessions.error = '';
    });
    builder.addCase(getClassSessions.fulfilled, (state, action) => {
      state.sessions.pending = false;
      state.sessions.complete = true;
      state.sessions.array = action.payload;
    });
    builder.addCase(getClassSessions.rejected, (state, action) => {
      state.sessions.pending = false;
      state.sessions.complete = false;
      state.sessions = Object.assign(state.sessions, action.payload);
      state.sessions.error = action.error ? action.error.message! : '';
    });

    //createClass
    builder.addCase(createClassSession.pending, (state) => {
      console.log('createClassSession.pending');
      state.session = {};
      state.session.saving = true;
      state.session.saved = false;
      state.session.error = '';
    });
    builder.addCase(createClassSession.fulfilled, (state, action) => {
      console.log('createClassSession.fulfilled');
      state.session.saving = false;
      state.session.saved = true;
      state.session = Object.assign(state.session, action.payload);
    });
    builder.addCase(createClassSession.rejected, (state, action) => {
      console.log('createClassSession.rejected', action);
      state.session.saving = false;
      state.session.saved = false;
      state.session = Object.assign(state.session, action.payload);
      state.session.error = action.error ? action.error.message! : '';
    });

    //updateClass
    builder.addCase(updateClassSession.pending, (state) => {
      state.session = {};
      state.session.saving = true;
      state.session.saved = false;
      state.session.error = '';
    });
    builder.addCase(updateClassSession.fulfilled, (state, action) => {
      state.session.saving = false;
      state.session.saved = true;
      state.session = Object.assign(state.session, action.payload);
    });
    builder.addCase(updateClassSession.rejected, (state, action) => {
      state.session.saving = false;
      state.session.saved = false;
      state.session = Object.assign(state.session, action.payload);
      state.session.error = action.error ? action.error.message! : '';
    });

    //cancelClass
    builder.addCase(cancelClassSession.pending, (state) => {
      state.cancelSession.saving = true;
      state.cancelSession.saved = false;
      state.cancelSession.error = '';
    });
    builder.addCase(cancelClassSession.fulfilled, (state, action) => {
      state.cancelSession.saving = false;
      state.cancelSession.saved = true;
      state.cancelSession = Object.assign(state.cancelSession, action.payload);
    });
    builder.addCase(cancelClassSession.rejected, (state, action) => {
      state.cancelSession.saving = false;
      state.cancelSession.saved = false;
      state.cancelSession = Object.assign(state.cancelSession, action.payload);
      state.cancelSession.error = action.error ? action.error.message! : '';
    });

    //startClass
    builder.addCase(startClassSession.pending, (state) => {
      state.startSession.saving = true;
      state.startSession.saved = false;
      state.startSession.error = '';
    });
    builder.addCase(startClassSession.fulfilled, (state, action) => {
      state.startSession.saving = false;
      state.startSession.saved = true;
      state.startSession = Object.assign(state.startSession, action.payload);
    });
    builder.addCase(startClassSession.rejected, (state, action) => {
      state.startSession.saving = false;
      state.startSession.saved = false;
      state.startSession = Object.assign(state.startSession, action.payload);
      state.startSession.error = action.error ? action.error.message! : '';
    });
  },
});

export const { sessionSliceClean } = classSessionSlice.actions;
export default classSessionSlice;
